<h2 mat-dialog-title>Discard Changes</h2>
<div mat-dialog-content>
    <p>Are you sure you want to discard changes?</p>
</div>
<div mat-dialog-actions align="end" class="modal-footer d-flex gap-10 flex-nowraps">
    <button class="btn btn-primary" (click)="submit()">Yes</button>
    <button class="btn btn-secondary" (click)="cancelDialog()">Cancel</button>
</div>